module.exports = __webpack_public_path__ + "static/media/logo-header-reverse.f494f98a.png";